
import { mapGetters } from "vuex";
import { SELECT_EMPRESA } from "@/core/services/store/auth.module";

const opcoesDias = (valores) =>
  valores.map((dias) => ({
    value: dias,
    text: `${dias} ${dias === 1 ? "dia" : "dias"}`,
  }));

export default {
  name: "GrupoEmpresaPendencias",
  data() {
    return {
      carregandoInicial: true,
      carregando: false,
      trocandoEmpresa: false,
      trocandoEmpresaId: null,
      grupo: null,
      central: null,
      filtros: {
        dias_vencimento: 7,
        dias_certificado: 30,
        dias_sem_movimento: 30,
      },
      filtrosLocais: {
        busca: "",
        severidade: "",
        categoria: "",
      },
      opcoesDiasVencimento: opcoesDias([3, 7, 15, 30]),
      opcoesDiasCertificado: opcoesDias([15, 30, 60, 90]),
      opcoesDiasSemMovimento: opcoesDias([15, 30, 60, 90]),
      opcoesSeveridade: [
        { value: "", text: "Todas" },
        { value: "CRITICA", text: "Crítica" },
        { value: "ATENCAO", text: "Atenção" },
      ],
      opcoesCategoria: [
        { value: "", text: "Todas" },
        { value: "FINANCEIRO", text: "Financeiro" },
        { value: "FISCAL", text: "Fiscal" },
        { value: "ESTOQUE", text: "Estoque" },
        { value: "OPERACIONAL", text: "Operacional" },
      ],
    };
  },
  computed: {
    ...mapGetters(["empresaContexto"]),
    empresaAtualId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
    cards() {
      const totais = this.central?.totais || {};
      return [
        {
          key: "criticas",
          label: "Pendências críticas",
          valor: Number(totais.criticas || 0),
          className: "text-danger",
        },
        {
          key: "atencao",
          label: "Precisam de atenção",
          valor: Number(totais.atencao || 0),
          className: "text-warning",
        },
        {
          key: "empresas",
          label: "Empresas afetadas",
          valor: Number(totais.empresas_afetadas || 0),
          className: "text-primary",
        },
        {
          key: "total",
          label: "Total de pendências",
          valor: Number(totais.pendencias || 0),
          className: "text-dark",
        },
      ];
    },
    pendenciasFiltradas() {
      const termo = this.normalizarTexto(this.filtrosLocais.busca);

      return (this.central?.pendencias || []).filter((pendencia) => {
        if (
          this.filtrosLocais.severidade &&
          pendencia.severidade !== this.filtrosLocais.severidade
        ) {
          return false;
        }
        if (
          this.filtrosLocais.categoria &&
          pendencia.categoria !== this.filtrosLocais.categoria
        ) {
          return false;
        }
        if (!termo) return true;

        return this.normalizarTexto(
          `${this.nomeEmpresa(pendencia.empresa)} ${pendencia.titulo} ${
            pendencia.descricao
          }`
        ).includes(termo);
      });
    },
  },
  methods: {
    normalizarTexto(valor) {
      return String(valor || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    nomeEmpresa(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa || ""}`
      );
    },
    labelSeveridade(severidade) {
      return severidade === "CRITICA" ? "Crítica" : "Atenção";
    },
    classeSeveridade(severidade) {
      return severidade === "CRITICA"
        ? "label-light-danger"
        : "label-light-warning";
    },
    formatarData(valor) {
      if (!valor) return "—";
      const [ano, mes, dia] = valor.split("-").map(Number);
      return new Intl.DateTimeFormat("pt-BR").format(
        new Date(ano, mes - 1, dia)
      );
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined) return "—";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(Number(valor));
    },
    limparFiltrosLocais() {
      this.filtrosLocais = {
        busca: "",
        severidade: "",
        categoria: "",
      };
    },
    async carregarInicial() {
      this.carregandoInicial = true;

      try {
        const { data } = await this.$http.get("/empresa/grupos/atual");
        this.grupo = data?.data || null;

        if (this.grupo) {
          await this.carregarPendencias();
        }
      } finally {
        this.carregandoInicial = false;
      }
    },
    async carregarPendencias() {
      if (!this.grupo?.id_grupo_empresa) return;
      this.carregando = true;

      try {
        const { data } = await this.$http.get(
          `/empresa/grupos/${this.grupo.id_grupo_empresa}/pendencias`,
          { params: { ...this.filtros } }
        );
        this.central = data?.data || null;
      } finally {
        this.carregando = false;
      }
    },
    async acessarEmpresa(pendencia) {
      const idEmpresa = Number(pendencia.id_empresa);
      if (
        this.trocandoEmpresa ||
        !idEmpresa ||
        idEmpresa === this.empresaAtualId
      ) {
        return;
      }

      this.trocandoEmpresa = true;
      this.trocandoEmpresaId = idEmpresa;

      try {
        await this.$store.dispatch(SELECT_EMPRESA, {
          id_empresa: idEmpresa,
        });
        this.$toast.success(
          `Empresa alterada para ${this.nomeEmpresa(pendencia.empresa)}.`
        );
        await this.redirecionarDashboard();
      } finally {
        this.trocandoEmpresa = false;
        this.trocandoEmpresaId = null;
      }
    },
    async redirecionarDashboard() {
      await this.$router.replace({ name: "dashboard" });
      window.location.reload();
    },
  },
  mounted() {
    this.carregarInicial();
  },
};
